import { render, staticRenderFns } from "./Beacons.vue?vue&type=template&id=4784b132&scoped=true&"
import script from "./Beacons.vue?vue&type=script&lang=js&"
export * from "./Beacons.vue?vue&type=script&lang=js&"
import style0 from "./Beacons.vue?vue&type=style&index=0&id=4784b132&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4784b132",
  null
  
)

export default component.exports